<template>
  <div class="schedule" >
    <el-divider content-position="left">材料登记表</el-divider>
    <el-row class="mb-20 search-row" :gutter="20">
      <el-col :xs="24" :sm="8" :md="5" :lg="4">
        <el-select
        v-model="searchArr.company_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称筛选公司"
        size="mini"
        clearable
        :remote-method="searchRemoteCompanyMethod"
        :loading="searchLoading"
        @change="handleSearchCompanyChange"
        style="width:100%"
      >
        <el-option
          v-for="searchCompany in searchCompanies"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="4">
      <el-date-picker
        v-model="searchArr.dateTime"
        type="month"
        size="mini"
        format="yyyy 年 MM 月"
        value-format="yyyy-MM"
        :picker-options="pickerOptions"
        @change="createdAtChange"
        placeholder="选择月份"
        style="width:100%"
      >
      </el-date-picker>
      </el-col>
      <el-col :xs="24" :sm="8" :md="5" :lg="3">
        <el-popover placement="bottom-start" width="600" v-model="visible">
            <el-form :model="searchArr" ref="searchForm" label-width="120px">
              <div style="float:left">
                <el-form-item label="金税盘：" prop="is_trust">
                  <el-radio-group v-model="searchArr.is_trust" size="mini" id="agree_at">
                    <el-radio-button label="1">客户</el-radio-button>
                    <el-radio-button label="2">我司</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="回卡单：" prop="back_bill_card">
                  <el-radio-group v-model="searchArr.back_bill_card" size="mini" id="agree_at">
                    <el-radio-button label=1>未知</el-radio-button>
                    <el-radio-button label=2>无</el-radio-button>
                    <el-radio-button label=3>有</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="销项汇总表：" prop="pin_summary">
                  <el-checkbox v-model="searchArr.pin_summary">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="销项发票：" prop="pin_summary_invoice">
                  <el-checkbox v-model="searchArr.pin_summary_invoice">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="进项认证清单：" prop="entry_certification_list">
                  <el-checkbox v-model="searchArr.entry_certification_list">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="进项发票：" prop="entry_certification_invoice">
                  <el-checkbox v-model="searchArr.entry_certification_invoice">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="银行回单：" prop="bank_slip">
                  <el-checkbox v-model="searchArr.bank_slip">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="银行对账单：" prop="bank_statement">
                  <el-checkbox v-model="searchArr.bank_statement">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="电子对账单：" prop="electronic_statement">
                  <el-checkbox v-model="searchArr.electronic_statement">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="社保完税证明：" prop="security_complete">
                  <el-checkbox v-model="searchArr.security_complete">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="公积金缴款单：" prop="provident_fund">
                  <el-checkbox v-model="searchArr.provident_fund">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="费用发票：" prop="expense_invoice">
                  <el-checkbox v-model="searchArr.expense_invoice">完成</el-checkbox>
                </el-form-item>
                <el-form-item label="全部完成：" prop="expense_invoice">
                  <el-checkbox v-model="searchArr.completion_status">完成</el-checkbox>
                </el-form-item>
              </div>
              <div style="float:right;margin-right: 25px;">
                <el-form-item label="财税负责人" prop="leader_id">
                  <el-cascader 
                    v-model="searchArr.leader_id" 
                    placeholder="请选择财税负责人" 
                    :options="allusersAddition" 
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" 
                    clearable 
                    filterable
                    :filter-method="filterOptions"
                    >
                  </el-cascader>
                  <!-- <el-select
                    v-model="searchArr.leader_id"
                    placeholder="请选择财税负责人筛选"
                    filterable
                    clearable
                    size="mini"
                  >
                    <el-option :value="null" label="NULL"></el-option>
                    <el-option
                      v-for="user in adminUsers"
                      :key="user.id"
                      :label="user.username"
                      :value="user.id"
                    >
                    </el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item label="理票会计" prop="acc_id">
                  <el-cascader 
                    v-model="searchArr.acc_id" 
                    placeholder="请选择理票会计" 
                    :options="allusersAddition" 
                    size="mini"
                    :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" 
                    clearable 
                    filterable
                    :filter-method="filterOptions"
                    >
                  </el-cascader>
              <!-- <el-select
                v-model="searchArr.acc_id"
                placeholder="请选择理票会计筛选"
                filterable
                clearable
                size="mini"
              >
                <el-option :value="null" label="NULL"></el-option>
                <el-option
                  v-for="user in adminUsers"
                  :key="user.id"
                  :label="user.username"
                  :value="user.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="客服会计" prop="ass_id">
              <el-cascader 
                v-model="searchArr.ass_id" 
                placeholder="请选择客服会计" 
                :options="allusersAddition" 
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" 
                clearable 
                filterable
                :filter-method="filterOptions"
                >
              </el-cascader>
              <!-- <el-select
                v-model="searchArr.ass_id"
                placeholder="请选择客服会计筛选"
                filterable
                clearable
                size="mini"
              >
                <el-option :value="null" label="NULL"></el-option>
                <el-option
                  v-for="user in adminUsers"
                  :key="user.id"
                  :label="user.username"
                  :value="user.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="记账报税会计" prop="advisory_id">
              <el-cascader 
                v-model="searchArr.advisory_id" 
                placeholder="请选择记账报税会计" 
                :options="allusersAddition" 
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" 
                clearable 
                filterable
                :filter-method="filterOptions"
                >
              </el-cascader>
              <!-- <el-select
                v-model="searchArr.advisory_id"
                placeholder="请选择记账报税会计筛选"
                filterable
                clearable
                size="mini"
              >
                <el-option :value="null" label="NULL"></el-option>
                <el-option
                  v-for="user in adminUsers"
                  :key="user.id"
                  :label="user.username"
                  :value="user.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="开票会计" prop="invoice_id">
              <el-cascader 
                v-model="searchArr.invoice_id" 
                placeholder="请选择开票会计" 
                :options="allusersAddition" 
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" 
                clearable 
                filterable
                :filter-method="filterOptions"
                >
              </el-cascader>
              <!-- <el-select
                v-model="searchArr.invoice_id"
                placeholder="请选择开票会计筛选"
                filterable
                clearable
                size="mini"
              >
                <el-option :value="null" label="NULL"></el-option>
                <el-option
                  v-for="user in adminUsers"
                  :key="user.id"
                  :label="user.username"
                  :value="user.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="业务员" prop="saler_id">
              <el-cascader 
                v-model="searchArr.saler_id" 
                placeholder="请选择业务员" 
                :options="allusersAddition" 
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }" 
                clearable 
                filterable
                :filter-method="filterOptions"
                >
              </el-cascader>
            </el-form-item>
              </div>
              <div style="float: left;width: 100%;text-align: center;">
                <el-form-item style="text-align: center">
                <el-button @click="resetForm" size="mini"
                  >重置</el-button>
                <el-button
                  type="primary"
                  @click="createdAtChange"
                  size="mini"
                  >查询</el-button>
              </el-form-item>
              </div>
            </el-form>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="setField"
          multiple
          filterable
          collapse-tags
          size="mini"
          placeholder="请选择自定义显示的字段"
          :popper-append-to-body="false"
          @change="handleColChange"
          style="width:100%"
        >
          <el-option
            v-for="field in fields"
            :key="field.id"
            :label="field.name"
            :value="field.id"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-table
      max-height="650"
      :data="companies"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column fixed prop="id" label="编号" width="50"> </el-table-column>
      <el-table-column fixed prop="company_name" label="企业名称" width="250">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.company_name" placement="top">
            <el-link
              type="primary"
              class="count-style"
              @click="handleCompanyInfoOpen(scope.row.id)"
              >{{ scope.row.company_name }}</el-link
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed prop="month" label="月份" width="100">{{ this.month }}</el-table-column>
      <el-table-column
        prop="is_trust"
        label="金税盘"
        v-if="setField.indexOf('is_trust') !== -1"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.is_trust === 1">客户</span>
          <span v-else-if="scope.row.is_trust === 2">我司</span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="back_bill_card"
        label="回单卡"
        v-if="setField.indexOf('back_bill_card') !== -1"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.back_bill_card === 1">未知</span>
          <span v-else-if="scope.row.back_bill_card === 2">无</span>
          <span v-else-if="scope.row.back_bill_card === 3">有</span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pin_summary"
        label="销项汇总表"
        width="250"
        v-if="setField.indexOf('pin_summary') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.pin_summary === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.pin_summary === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'pin_summary')"
                circle></el-button>
              </el-tooltip>
              <img
              v-if="scope.row.cent.pin_summary_buphoto"
              style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.pin_summary_buphoto ? scope.row.cent.pin_summary_buphoto : ''">
              <el-tooltip
               v-if="scope.row.cent.pin_summary_operator"
               :content="scope.row.cent ? scope.row.cent.pin_summary_operator + ' ' +  scope.row.cent.pin_summary_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.pin_summary_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.pin_summary_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="pin_summary_invoice"
        label="销项发票"
        width="250"
        v-if="setField.indexOf('pin_summary_invoice') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.pin_summary_invoice === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.pin_summary_invoice === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'pin_summary_invoice')"
                circle></el-button>
              </el-tooltip>
              <img
              v-if="scope.row.cent.pin_summary_invoice_buphoto"
              style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.pin_summary_invoice_buphoto ? scope.row.cent.pin_summary_invoice_buphoto : ''">
              <el-tooltip
               v-if="scope.row.cent.pin_summary_invoice_operator"
               :content="scope.row.cent ? scope.row.cent.pin_summary_invoice_operator + ' ' +  scope.row.cent.pin_summary_invoice_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.pin_summary_invoice_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.pin_summary_invoice_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="entry_certification_list"
        label="进项认证清单"
        width="250"
        v-if="setField.indexOf('entry_certification_list') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.entry_certification_list === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.entry_certification_list === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'entry_certification_list')"
                circle></el-button>
              </el-tooltip>
              <img
              v-if="scope.row.cent.entry_certification_list_buphoto"
              style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.entry_certification_list_buphoto ? scope.row.cent.entry_certification_list_buphoto : ''"
              >
              <el-tooltip
               v-if="scope.row.cent.entry_certification_list_operator"
               :content="scope.row.cent ? scope.row.cent.entry_certification_list_operator + ' ' +  scope.row.cent.entry_certification_list_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.entry_certification_list_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.entry_certification_list_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="entry_certification_invoice"
        label="进项发票"
        width="250"
        v-if="setField.indexOf('entry_certification_invoice') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.entry_certification_invoice === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.entry_certification_invoice === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'entry_certification_invoice')"
                circle></el-button>
              </el-tooltip>
              <img
              v-if="scope.row.cent.entry_certification_invoice_buphoto"
              style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.entry_certification_invoice_buphoto ?  scope.row.cent.entry_certification_invoice_buphoto : ''">
              <el-tooltip
               v-if="scope.row.cent.entry_certification_invoice_operator"
               :content="scope.row.cent ? scope.row.cent.entry_certification_invoice_operator + ' ' +  scope.row.cent.entry_certification_invoice_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.entry_certification_invoice_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.entry_certification_invoice_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="bank_slip"
        label="银行回单"
        width="250"
        v-if="setField.indexOf('bank_slip') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.bank_slip === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.bank_slip === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'bank_slip')"
                circle></el-button>
              </el-tooltip>
              <img
              v-if="scope.row.cent.bank_slip_buphoto"
              style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.bank_slip_buphoto ?  scope.row.cent.bank_slip_buphoto : ''">
              <el-tooltip
               v-if="scope.row.cent.bank_slip_operator"
               :content="scope.row.cent ? scope.row.cent.bank_slip_operator + ' ' +  scope.row.cent.bank_slip_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.bank_slip_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.bank_slip_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="bank_statement"
        label="银行对账单"
        width="250"
        v-if="setField.indexOf('bank_statement') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.bank_statement === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.bank_statement === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'bank_statement')"
                circle></el-button>
              </el-tooltip>
              <img
                v-if="scope.row.cent.bank_statement_buphoto"
                style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.bank_statement_buphoto ? scope.row.cent.bank_statement_buphoto : ''"
              >
              <el-tooltip
               v-if="scope.row.cent.bank_statement_operator"
               :content="scope.row.cent ? scope.row.cent.bank_statement_operator + ' ' +  scope.row.cent.bank_statement_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.bank_statement_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.bank_statement_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="electronic_statement"
        label="电子对账单"
        width="250"
        v-if="setField.indexOf('electronic_statement') !== -1"
      >
        <template slot-scope="scope">
          <div  style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.electronic_statement === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.electronic_statement === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'electronic_statement')"
                circle></el-button>
              </el-tooltip>
              <img
                v-if="scope.row.cent.electronic_statement_buphoto"
                style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.electronic_statement_buphoto ? scope.row.cent.electronic_statement_buphoto : ''"
              >
              <el-tooltip
               v-if="scope.row.cent.electronic_statement_operator"
               :content="scope.row.cent ? scope.row.cent.electronic_statement_operator + ' ' +  scope.row.cent.electronic_statement_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.electronic_statement_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.electronic_statement_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="security_complete"
        label="社保完税证明"
        width="250"
        v-if="setField.indexOf('security_complete') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.security_complete === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.security_complete === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'security_complete')"
                circle></el-button>
              </el-tooltip>
              <img
                v-if="scope.row.cent.security_complete_buphoto"
                style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.security_complete_buphoto ? scope.row.cent.security_complete_buphoto : ''"
              >
              <el-tooltip
               v-if="scope.row.cent.security_complete_operator"
               :content="scope.row.cent ? scope.row.cent.security_complete_operator + ' ' +  scope.row.cent.security_complete_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.security_complete_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.security_complete_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="provident_fund"
        label="公积金缴款单"
        width="250"
        v-if="setField.indexOf('provident_fund') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.provident_fund === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.provident_fund === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'provident_fund')"
                circle></el-button>
              </el-tooltip>
              <img
              v-if="scope.row.cent.provident_fund_buphoto"
              style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.provident_fund_buphoto ? scope.row.cent.provident_fund_buphoto : ''"
              >
              <el-tooltip
               v-if="scope.row.cent.provident_fund_operator"
               :content="scope.row.cent ? scope.row.cent.provident_fund_operator + ' ' +  scope.row.cent.provident_fund_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.provident_fund_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.provident_fund_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="expense_invoice"
        label="费用发票"
        width="250"
        v-if="setField.indexOf('expense_invoice') !== -1"
      >
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
              <el-tooltip content="完成标识" placement="top">
                <el-button
                :type="scope.row.cent.expense_invoice === 1 ? 'success' : 'info'"
                :icon="scope.row.cent.expense_invoice === 1 ? 'el-icon-check' : 'el-icon-edit'"
                size="mini"
                @click="handleInform(scope.row, 'expense_invoice')"
                circle></el-button>
              </el-tooltip>
              <img
                v-if="scope.row.cent.expense_invoice_buphoto"
                style="margin-right: .2rem;width: 28px;height: 28px; margin-left: .3rem; border-radius: 50px;"
                :src="scope.row.cent.expense_invoice_buphoto ? scope.row.cent.expense_invoice_buphoto : ''"
              >
              <el-tooltip
               v-if="scope.row.cent.expense_invoice_operator"
               :content="scope.row.cent ? scope.row.cent.expense_invoice_operator + ' ' +  scope.row.cent.expense_invoice_time : ''"
               placement="top"
              >
                <div style="color: #409EFF;">
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.expense_invoice_operator) : '' }}
                  </span>
                  <span class="hide-style" style="font-size: 0.1rem">
                    {{ scope.row.cent ? (scope.row.cent.expense_invoice_time) : '' }}
                  </span>
                </div>
              </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="completion_status" label="完成" width="250">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
            <span v-if="scope.row.cent.completion_status === '全部完成'">全部完成</span>
            <span v-else></span>
            <el-tooltip
              style="margin-right: .2rem;height: 28px; margin-left: .3rem"
              v-if="scope.row.cent.completion_status === '全部完成'"
              :content="scope.row.cent.statistical_completion_time"
              placement="top"
            >
              <div style="color: #409EFF;">
                <span style="font-size: 0.1rem;line-height: 28px;">
                  {{ scope.row.cent ? (scope.row.cent.statistical_completion_time) : '' }}
                </span>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" prop="remarks" label="操作" width="100">
        <template slot-scope="scope" >
          <el-tooltip content="备注" placement="top">
            <el-button
            icon="el-icon-circle-plus"
            size="mini"
            :type="scope.row.cent.remarks ? 'primary' : 'info'"
            @click="handleRemarks(scope.row)"
            circle></el-button>
          </el-tooltip>
          <el-tooltip content="历史记录" placement="top">
            <el-button
            type="info"
            icon="el-icon-time"
            size="mini"
            @click="Registrarione(scope.row)"
            circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="typePerPage"
        background
      >
      </el-pagination>
    </div>
    <el-drawer
      :title="'操作记录【' + companyName + '】'"
      :visible.sync="RegistrarioneDrawer"
      direction="rtl"
      size="50%"
      fullscreen
    >
      <div style="margin-left: 0.4rem;margin-right: 0.4rem">
        <div class="m-tabs-content_amt">
          <div class="blocka">
            <el-tabs v-model="showTabPane" type="border-card">
              <el-tab-pane label="操作记录" name="first">
                <el-collapse
                  v-for="(records, index) in editHistories"
                  :key="index"
                  accordion
                  v-model="activeName"
                  style="border-bottom: 1px solid #ebeef5"
                >
                  <el-collapse-item
                    :title="records.month + ' 操作记录详情'"
                    :name="index + 1"
                  >
                    <el-timeline>
                      <el-timeline-item
                        :timestamp="item.created_at"
                        v-for="(item, index) in records.record"
                        :key="index"
                        placement="top"
                      >
                        <el-card>
                          <p v-if="item.operation">{{ item.ope_name }} {{ item.operation }}</p>
                          <p v-if="!item.operation">无</p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="备注"
      :visible.sync="handleRemarksDrawer"
      direction="rtl"
      :before-close="handleEditDrawerClose"
      size="50%">
      <div style="padding: 0.2em 1.4em; ">
        <el-form
          :model="saveData"
          label-width="110px"
        >
        <el-form-item label="备注信息" prop="remark">
            <el-input
              size="mini"
              type="textarea"
              v-model="saveData.remarks"
              style="white-space: pre"
              :rows="5"
            >
            </el-input>
          </el-form-item>
        <el-form-item label="上传截图/文件" prop="url">
            <el-upload
              :action="actionHost + '/api/upload/companiesfinance/uploadRelated'"
              :headers="uploadHeader"
              ref="uploadMutiple"
              multiple
              :file-list="fileList"
              :limit="10"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :on-change="handleAvatarChange"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
            >
              <el-button size="mini" type="primary">点击上传</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
                style="color: #909399; margin-top: -0.1rem"
              >
              单次上传最多10个文件或图片
              </div>
            </el-upload>
              <div style="margin-top: 0.2rem">
                <span
                  ><i class="el-icon-s-opportunity" style="color: #fb894c"
                    >点击下方，Ctrl+v上传</i
                  ></span
                >
              </div>
              <div
                id="preview"
                @paste="handlePaste"
                style="border: 3px dashed #409eff;border-radius: 15px;text-indent: 2em;"
              >
                <span style="opacity: 0.5">先点击此处 再按Ctrl+V 粘贴至此处</span>
              </div>
            </el-form-item>
          <el-form-item>
            <div style="text-align: right">
              <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
            </div>
          </el-form-item>
        </el-form>
        <div v-if="remarksLog.length > 0" style="padding: 0.5rem">
          <el-divider content-position="left"><span
              style="color: #409eff; font-size: 0.3rem; font-weight: bold">备注操作记录</span></el-divider>
          <el-timeline style="margin-top: 0.5rem">
            <el-timeline-item v-for="(activity, index) in remarksLog" :key="index"
              :timestamp="activity.created_at">
              <p style="margin-bottom: 0.3rem">{{ activity.ope_name }}</p>
              <p style="margin-bottom: 0.3rem">{{ activity.operation }} </p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content_amt" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId" @reloadTable="reloadTable"></company-info>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import CompanyInfo from 'common/CompanyInfo'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: 'MaterialRegistration',
  components: {
    CompanyInfo
  },
  data () {
    return {
      visible: false,
      npage: 1,
      typePerPage: 10,
      total: null,
      month: '',
      companyName: '',
      showTabPane: 'first',
      adminUsers: [],
      activeName: 1,
      searchArr: {
        company_id: '',
        dateTime: '',
        is_trust: '',
        back_bill_card: '',
        pin_summary: '',
        pin_summary_invoice: '',
        entry_certification_list: '',
        entry_certification_invoice: '',
        bank_slip: '',
        bank_statement: '',
        electronic_statement: '',
        security_complete: '',
        provident_fund: '',
        expense_invoice: '',
        completion_status: '',
        leader_id: '',
        acc_id: '',
        ass_id: '',
        advisory_id: '',
        invoice_id: '',
        saler_id: ''
      },
      cha: [],
      needUrl: [],
      fileList: [],
      uploadHeader: { Authorization: localStorage.token },
      saveData: {
        company_id: '',
        month: '',
        remarks: ''
      },
      remarksOld: '',
      setField: [],
      editHistories: [],
      remarksLog: [],
      searchCompanies: [],
      companies: [],
      companyInfoDrawer: false,
      companyInfoId: null,
      searcher: null,
      searchLoading: false,
      RegistrarioneDrawer: false,
      handleRemarksDrawer: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      fields: [
        { id: 'is_trust', name: '金税盘' },
        { id: 'back_bill_card', name: '回单卡' },
        { id: 'pin_summary', name: '销项汇总表' },
        { id: 'pin_summary_invoice', name: '销项发票' },
        { id: 'entry_certification_list', name: '进项认证清单' },
        { id: 'entry_certification_invoice', name: '进项认证发票' },
        { id: 'bank_slip', name: '银行回单' },
        { id: 'bank_statement', name: '银行对账单' },
        { id: 'electronic_statement', name: '电子对账单' },
        { id: 'security_complete', name: '社保完税证明' },
        { id: 'provident_fund', name: '公积金缴款单' },
        { id: 'expense_invoice', name: '费用发票' }
      ],
      adminOptions: [],
      additionalData: { value: '无', label: 'NULL' },
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    }, 
    allusersAddition() {
      return [...this.adminOptions, this.additionalData]
    },  
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  },
  methods: {
    handleColChange () {
      this.$axios.post('/api/companies_finance/set_field', this.setField).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.$message.success(data.msg)
        }
      })
    },
    reloadTable () {
      this.loadTable()
    },
    handleCompanyInfoOpen (cid) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyInfoId = cid
      })
    },
    // 监听粘贴操作
    handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        file = items[i].getAsFile()
      }
      if (this.fileList.length >= this.limit) {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
        return
      }
      this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
      this.$refs.uploadMutiple.submit() // 提交图片上传队列
    },
    beforeAvatarUpload (file) {
      const isLt100M = file.size / (1024 * 100) < 100
      if (!isLt100M) {
        this.$message.error('上传总大小不能超过 100MB!')
        return false
      }
      // return isJPG && isLt2M
    },
    handleAvatarSuccess (res, file) {
      if (res.code === 1) {
        this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
      }
    },
    handleAvatarChange (res, file) {
      this.fileList = file
      this.change = true
    },
    handlePictureCardPreview (file) {
      this.fileNameList = file.name
    },
    handleRemove (file, fileList) {
      this.needUrl.map((item, index) => {
        if (item.uid === file.uid) {
          this.needUrl.splice(index, 1)
        }
      })
      this.fileList = fileList
      this.change = true
    },
    resetForm () {
      this.searchArr.company_id = ''
      this.searchArr.dateTime = ''
      this.searchArr.is_trust = ''
      this.searchArr.back_bill_card = ''
      this.searchArr.pin_summary = ''
      this.searchArr.pin_summary_invoice = ''
      this.searchArr.entry_certification_list = ''
      this.searchArr.entry_certification_invoice = ''
      this.searchArr.bank_slip = ''
      this.searchArr.bank_statement = ''
      this.searchArr.electronic_statement = ''
      this.searchArr.security_complete = ''
      this.searchArr.provident_fund = ''
      this.searchArr.expense_invoice = ''
      this.searchArr.leader_id = ''
      this.searchArr.acc_id = ''
      this.searchArr.ass_id = ''
      this.searchArr.advisory_id = ''
      this.searchArr.invoice_id = ''
      this.searchArr.saler_id = ''
      this.visible = false
      this.loadTable()
    },
    handleSave () {
      if (this.saveData.remarks === '' || this.saveData.remarks === null) {
        this.$message.error('请填写备注信息')
        return false
      }
      console.log('======', this.fileList)
      var oldId = this.fileList.map(item => {
        return item.id
      })
      this.$axios.post('/api/admin/companies_finance/savetext', {
        saveData: this.saveData,
        file: this.needUrl,
        oldId: oldId,
        cha: this.cha,
        remarksOld: this.remarksOld
      }).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.remarksLog = data.data.remarksLog ? data.data.remarksLog : []
          this.$message.success(data.msg)
          this.loadTable()
          this.handleRemarksDrawer = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleRemarks (row) {
      this.cha = []
      this.needUrl = []
      this.fileList = []
      this.saveData.company_id = row.id
      this.saveData.month = this.month
      this.saveData.remarks = this.remarksOld = row.cent.remarks ? row.cent.remarks : ''
      this.fileList = row.cent.mat_file ? row.cent.mat_file : []
      this.cha = this.fileList.map(item => {
        return item.id
      })
      this.companyName = row.company_name
      this.$axios
        .get(
          '/api/admin/companies_finance/remarkslog?page=' +
            this.npage +
            '&pageSize=' + this.typePerPage +
            '&company_id=' + row.id +
            '&month=' + this.month
        )
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.remarksLog = data.data.remarksLog
          }
        })
      this.handleRemarksDrawer = true
    },
    Registrarione (row) {
      this.companyName = row.company_name
      this.$axios
        .get(
          '/api/admin/companies_finance/mrlog?page=' +
            this.npage +
            '&pageSize=' + this.typePerPage +
            '&company_id=' + row.id +
            '&month=' + this.month
        )
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.RegistrarioneDrawer = true
            this.editHistories = data.data.editHistories
          }
        })
    },
    handleInform (row, coml) {
      this.$axios
        .get(
          '/api/admin/companies_finance/clickedit?page=' +
            this.npage +
            '&pageSize=' + this.typePerPage +
            '&company_id=' + row.id +
            '&company_name=' + row.company_name +
            '&month=' + this.month +
            '&coml=' + coml +
            '&val=' + row.cent[coml]
        )
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.loadTable()
          }
        })
    },
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanys(query)
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchCompanies = data.data.companies
        }
      })
    },
    handleSearchCompanyChange (val) {
      this.total = 0
      this.npage = 1
      this.loadTable(true)
    },
    createdAtChange (val) {
      this.submitForm('searchForm')
    },
    submitForm (formName) {
      this.npage = 1
      this.total = 0
      this.visible = false
      this.loadTable(true)
    },
    loadTable () {
      this.$axios
        .get(
          '/api/admin/companies_finance/companies?page=' +
            this.npage +
            '&pageSize=' + this.typePerPage +
            this.searchStr
        )
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.companies = data.data.pageData.data
            this.total = data.data.pageData.total
            this.month = data.data.month
            this.adminUsers = data.data.adminUsers
            this.adminOptions = data.data.adminOptions
            this.setField = []
            if (data.data.fields.length > 0) {
              this.setField = data.data.fields
            } else {
              for (let k = 0; k < this.fields.length; k++) {
                this.setField.push(this.fields[k].id)
              }
            }
          }
        })
    },
    handleClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.companyInfoDrawer = false
          this.resetForm('typeForm')
          this.typeEditDrawer = false
          this.cityObj = {}
          this.areaObj = {}
          this.areaparkObj = {}
          done()
        })
        .catch(_ => {})
    },
    handleEditDrawerClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetForm()
          done()
        })
        .catch(_ => {})
    },
    handleCompanyInfoBeforeClose (done) {
      this.companyInfoId = null
      done()
    },
    // 分页
    handleSizeChange (val) {
      this.typePerPage = val
      this.loadTable()
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  }
}
</script>
<style lang="stylus" scoped>
.schedule {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper >>> .el-drawer {
overflow-y: auto;
}

.el-form .el-select {
width: 100%;
}

.el-collapse {
border-bottom: 0;
border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
color: #4C87FC;
font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
color: #4C87FC;
}

.el-drawer .el-form-item {
margin-bottom: 0.3rem !important;
}

.el-timeline >>> .el-timeline-item__content {
line-height: 1.7;
margin-bottom: 0.3rem !important;
}

.companyFiles >>> .el-card__header {
padding: 0.2rem;
font-size: 0.26rem;
}

.companyFiles >>> .el-card__body {
padding: 0.1rem;
}

.companyFiles >>> .el-table__header th {
color: #333333;
background-color: #ECF4FF;
}

.companyFiles {
marginLeft();

.hide-style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
}

.el-button+.el-button {
margin-left: 0;
}

.tr {
text-align: right;
}

.mt-10 {
margin-top: 0.2rem;
}

.mt-20 {
margin-top: 0.4rem;
}

.el-form-item {
margin-bottom: 0.1rem;
}

.el-dialog .el-select {
width: 100%;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
  margin-top: 1.5rem
}

.active {
background-color: #f5f5f5;
color: #409eff;
}

.col-box {
min-height: calc(100vh - 210px);
border-right: 1px solid #ebebeb;

.col-box-head {
  height: 0.56rem;
  padding: 0 0.2rem;
  overflow: hidden;

  .col-head-title {
    line-height: 0.56rem;
    color: #5789f4;
  }
}

.col-com-items {
  min-height: calc(100vh - 210px);
  height: 6rem;
  overflow-y: auto;
  padding: 0 0.2rem;
}

.col-box-item:hover {
  background-color: #f5f5f5;
}

.col-box-item {
  height: 0.8rem;
  line-height: 0.8rem;
  cursor: pointer;
  border-bottom: 1px solid #ebebeb;

  .col-box-centent {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
}

.files-head {
  height: 0.56rem;
  line-height: 0.56rem;
  padding: 0 0.2rem;

  .files-head-title {
    color: #5789f4;
  }
  .file-up {
    color: #5789f4;
    text-align: right;
    font-size: 0.5rem;

    .file-up-icon {
      cursor: pointer;
    }
  }
}

.up-link {
  width: 1.4rem;
  text-align: right;
}

.file-logs-box {
  min-height: calc(100vh - 210px);
  height: 6rem;
  padding: 0 0.2rem;
  overflow-y: auto;

  .file-box {
    display: flex;
  }

  .file-remark {
    color: rgb(94, 109, 130);
    font-size: 0.26rem;
    padding: 0.1rem;
  }
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon {
  font-size: 0.5rem;
}
.hide-style{
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.addCon{
  margin: .4rem .5rem;
  text-align: right;
}
.el-drawer__wrapper >>> .el-drawer__header span {
  color: #4c87fc;
  font-size: 0.36rem;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance_register/MaterialRegistration.vue